import React from 'react'
import { Bar } from 'react-chartjs-2';

const Dompet = (props) => {

    const pockets = props.data;



    return (
            <div className='card'>
                <header className='card-header'>
                    <p className='card-header-title is-size-7'>Dompet</p>
                </header>
                <div className='card-content'>
                    <Bar
                        data={{
                            labels: pockets.map((item) => item.pocket),
                            datasets: [
                                {
                                    label: "Masuk",
                                    data: pockets.map((item) => item.debit / 1000),
                                    backgroundColor: 'rgba(0,0,255,0.5',
                                },
                                {
                                    label: "Keluar",
                                    data: pockets.map((item) => item.kredit / 1000),
                                    backgroundColor: 'rgba(255,0,0,0.5)',
                                }
                            ]
                        }}
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: 'bottom',
                                },
                                title: {
                                    display: false,
                                    text: 'Debit (Pemasukan) x1.000'
                                }
                            },
                            scales: {
                                y: {
                                    title: {
                                        display: true,
                                        text: 'Rupiah (Rp.) x 1000'
                                    },
                                    // min: 0,
                                    // max: 10000,
                                    beginAtZero: true,
                                    ticks: {
                                        // forces step size to be 50 units
                                        //stepSize: 500
                                    }
                                }
                            }
                        }}
                        height={300}
                    />
                </div>
            </div>
    )
}

export default Dompet
